"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPayment = void 0;
var defaultPayment = exports.defaultPayment = {
  claimReimbursement: {
    validation: {
      required: 'Please choose an option.'
    }
  }
};